import baseConfig, { Config } from "../../utils/config";

// Specific configuration for Demo 2 - Mechanical Mode
const demo2Config: Config = {
  ...baseConfig,
  AppName: "CADViewer Visual Query:",      // BP Retail Demo 2025",
  initFileName: "",
  DisplayCoordinatesMenu: false, // display the CADViewer coordinates menu
  displayTopNavigationBar: false, // display the layout /model space navigation menu
  setSpaceObjectsCustomMenu: false, // display the SpaceObject Navigation menu
  hideLeftHamburgerMenu: false, // hide the left hamburger menu
  BaseAttributes: {
    fill: "#ffffff", //'#d8e1e3', // '#ffd7f4', //'#D3D3D3',   // #FFF   #ffd7f4
    "fill-opacity": 0.0,
    stroke: "#CCC", //  #CCC
    "stroke-width": 0.0,
    "stroke-opacity": 0.0,
    "stroke-linejoin": "round",
  },

  // Mouse over highlight attributes of Space Object

  HighlightAttributes: {
    fill: "ffffff", //"#ffd7f4", //"#a4d7f4",  // '#ffd7f4'
    "fill-opacity": 0.0,
    stroke: "#ffd7f4", // "#a4d7f4",
    "stroke-width": 0.0,
    "stroke-opacity": 0.0,
  },

  // Mouse click highlight attributes of Space Object

  SelectAttributes: {
    fill: "#ffffff", //"#ed39a5", //"#5BBEF6",   //#ed39a5
    "fill-opacity": 0.0,
    stroke: "#3E20E7", //"#ed39a5", //"#5BBEF6",  // #ed39a5   //rgb(62, 32, 231)
    "stroke-width": 1,
    "stroke-linejoin": "round",
    "stroke-opacity": 0.8,
  },
  enableQuickPdfPrint: true,
  chatResultDisplayMetrics: true, // Set to true to display metrics in the chat results
  postFixServerToken: false,
  globalApplicationFilesLocation:
    "https://server.demo.cadviewer.com/content/custom/realcomm_presentation/json/application/",
  propertySVGFilesLocation:
    "https://server.demo.cadviewer.com/content/custom/realcomm_presentation/svg/",
  propertyJSONFilesLocation:
    "https://server.demo.cadviewer.com/content/custom/realcomm_presentation/json/property/",

  propertyJSONFilesEnableDistance: true,
  propertyJSONFilesEnableLayerColors: true,
  topPaneScrollDownTitle: "Choose information plan/layer:", // set te title of the top pane scroll down menu
  displayTopPaneScrollDownButton: true, // display the top pane scroll down button, true to show the top pane scroll down menu
  topRowItem1: "Property Name:", // top row items
  topRowItem2: "Property Number:", // top row items
  topRowItem3: "Plan Name:", // top row items
  enableRightJSONModalPanel: true, // enabling JSON load right side pane for property selection
  enableRightFileModalPanel: false,
  defautlPropertyToLoad: {
    propertyNumber: "4279", //"2339", // set to undefined to disable default property
    planName: "LP1", //"LP0", // set to undefined to disable default plan
  },
  setCADViewerSkin: "light-skin", //CADViewer Skin lightgray, black, deepblue, light-skin, dark-skin
  showLogoOnSideBarLeftPanel: false, // Set to true to display the logo on the side bar left panel
  cvjs_styleQTip_width: "320px", // set the width of the popup

  enableHelperMethods: true,
  enableHelpersMethodsGroup_Highlight: false,
  enableHelpersMethodsGroup_Group: false,
  enableHelpersMethodsGroup_Manipulate: false,
  enableHelpersMethodsGroup_Insert: false,
  enableHelpersMethodsGroup_CustomCanvas: false,
  enableHelpersMethodsGroup_SpaceArea: false,
  enableHelpersMethodsGroup_RedlineArea: false,
  enableHelpersMethodsGroup_VizQueryDemo: true,
  enableHelpersMethodsGroup_Brookfield: false,
  enableHelpersMethodsGroup_UrbanEdge: false,
  enableHelpersMethodsGroup_UicEdu: false,
  enableHelpersMethodsGroup_Insuremep: false,

  enableAIChat: false,
  useAIChatV5: true,
  useAIChatV4: false,
  aiChatV2Endpoint: "/ai/v2/chat", // Endpoint for the new AI chat service
  aiChatV3Endpoint: "/ai/v3/search-spaces", // Endpoint for the V3 AI chat service
  aiChatV4Endpoint: "", // Endpoint for the V4 AI chat service
  aiChatV5Endpoint: "", // Endpoint for the V5 proxy (supports snowflake and python)
  aiChatV5Provider: "python" as "snowflake" | "python" | "snowflake-agent", // Provider for the V5 proxy endpoint
  aiChatV5Mode: "Test" as "Test" | "Prod", // Mode for the V5 proxy endpoint (defaults to "Test")



  setBPLayerChange: true, // SET custom HEADER for BP Retail Layer Change  - 10.55.2

  defaultLayerColorsOnLoad: [
    // set the layer colors for BP Retail
    { layer: "0", color: "#000" },
    { layer: "ARCH-DOORS-EXTERIOR", color: "#000" },
    { layer: "ARCH-DOORS-INTERIOR", color: "#000" },
    { layer: "ARCH-FEATURES", color: "#000" },
    { layer: "ARCH-OPENINGS-ABOVE", color: "#000" },
    { layer: "ARCH-OPENINGS-BELOW", color: "#000" },
    { layer: "ARCH-SITE-MISCELLANEOUS", color: "#000" },
    { layer: "ARCH-SYMBOLS", color: "#000" },
    { layer: "ARCH-WALLS-EXTERIOR", color: "#000" },
    { layer: "ARCH-WALLS-INTERIOR", color: "#000" },
    { layer: "BD-STORAGE", color: "#000" },
    { layer: "TABLE-ACREAGE", color: "#000" },
    { layer: "SITE-BUILDING", color: "#000" },
    { layer: "SITE-CURB", color: "#000" },
    { layer: "SITE-PARKING", color: "#000" },
    { layer: "TABLE-PARKING-DATA", color: "#000" },
    { layer: "SITE-PROPERTY-LINE", color: "#000" },
    { layer: "SITE-SIDEWALK", color: "#000" },
    { layer: "SITE-MISCELLANEOUS", color: "#000" },
    { layer: "SITE-STRIPING", color: "#000" },
    { layer: "SITE-TEXT", color: "#000" },
    { layer: "DIMENSIONS-STRUCTURAL-GRID", color: "#000" },
    { layer: "DIMENSIONS-TENANT", color: "#000" },
    { layer: "STRUCTURAL-EXPANSION-JOINT", color: "#000" },
    { layer: "KIOSK-SF", color: "#000" },
    { layer: "TENANT-SPNO", color: "#000" },
    { layer: "TENANT-SF", color: "#000" },
    { layer: "KIOSK-NAME", color: "#000" },
    { layer: "TENANT-OCCUPANCY-COST", color: "#000" },
    { layer: "TENANT-R12-SALES", color: "#000" },
    { layer: "TENANT-NAME", color: "#000" },
    { layer: "STRUCTURAL-SHEAR-WALL", color: "#000" },
    { layer: "STRUCTURAL-BRACING", color: "#000" },
    { layer: "STRUCTURAL-COLUMNS", color: "#000" },
    { layer: "STRUCTURAL-GRID-TAGS", color: "#000" },
    { layer: "ARCH-WALLS-DEMISING", color: "#000" },
    { layer: "TENANT-STOREFRONT-LEASELINE", color: "#000" },
    { layer: "TEXT-GENERAL", color: "#000" },
    { layer: "TEXT-MISCELLANOUS", color: "#000" },
    { layer: "TEXT-NOTES", color: "#000" },
    { layer: "TITLEBLOCK", color: "#000" },
    { layer: "UTILITIES-ELECTRICAL", color: "#000" },
    { layer: "UTILITIES-EQUIPMENT", color: "#000" },
    { layer: "UTILITIES-HVAC", color: "#000" },
    { layer: "UTILITIES-PLUMBING", color: "#000" },
    { layer: "KIOSK-SPNO", color: "#000" },
    { layer: "XREF", color: "#000" },
    { layer: "ARCH-CORPORATE-OFFICE-EQUIPMENT", color: "#000" },
    { layer: "ARCH-CORPORATE-OFFICE-GLAZING", color: "#000" },
    { layer: "FURNITURE-CORPORATE-OFFICE-BLACK", color: "#000" },
    { layer: "SF-CORPORATE-OFFICE-CONFERENCE-ROOM-PL", color: "#000" },
    { layer: "SF-CORPORATE-OFFICE-ENCLAVE-PL", color: "#000" },
    { layer: "SF-CORPORATE-OFFICE-STORAGE-PL", color: "#000" },
    { layer: "TEXT-CORPORATE-OFFICE-FLOOR-IDENTIFICATION", color: "#000" },
  ],
  omitSpaceObjectLayerHandling: false
};

export default demo2Config;
